// eslint-disable-next-line
import { useRef, useState, useEffect, useCallback, HTMLInputElement } from 'react';

/**
 * @param {{limit?: number,accept?: string,onRead: (data:string[]) => void,onChange: (file) => void}} config
 * @returns {{selectFile(): void, files: any[], data:string[], input:HTMLInputElement }}
 * @description data is an array of files converted to base64
 *
 */

const useStorage = (config = { limit: 1, accept: '*', name: '' }) => {
    const reader = useRef(new FileReader());
    const storageRef = useRef();
    const [files, setFiles] = useState([]);
    const [data, setData] = useState([]);

    const handleFileReader = useCallback(
        (files) => {
            if (!files || !files.length) return null;
            let items = [];
            reader.current.onload = (ec) => {
                ec.target.result && items.push(ec.target.result);
                if (files.length > 0) {
                    reader.current.readAsDataURL(files.pop());
                    return null;
                }
                config.onRead && config.onRead(items);
                setData(items);
            };

            reader.current.readAsDataURL(files.pop());
        },
        [config, reader]
    );

    const handleFileInput = useCallback(() => {
        if (!storageRef.current) {
            storageRef.current = document.createElement('input');
            storageRef.current.type = 'file';
            storageRef.current.accept = config.accept;
            storageRef.current.name = config.name;
            storageRef.current.multiple = true;
        }

        storageRef.current.onchange = (ec) => {
            if (storageRef.current.files) {
                const files = [...storageRef.current.files].slice(0, config.limit);
                config.onChange && config.onChange(files);
                setFiles((state) => [...state, ...files]);
                handleFileReader(files);
            }
            ec.target.value = '';
        };
    }, [storageRef, handleFileReader, config]);

    useEffect(() => {
        handleFileInput();
    }, [handleFileInput]);

    const handleSelectFile = () => {
        storageRef.current.click();
    };

    return {
        selectFile: handleSelectFile,
        files,
        data,
        input: storageRef
    };
};

export default useStorage;
